import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const BrandAliasInput = z.object({
  alias: z.string().min(1),
  regexMatch: z.string().refine(
    (pattern) => {
      try {
        new RegExp(pattern);
        return true;
      } catch {
        return false;
      }
    },
    { message: "Invalid regular expression" },
  ),
});

export const setAdminBrandAliases = unaryRpc({
  name: "setAdminBrandAliases",
  input: z.object({
    teamId: zExt.objectId(),
    aliases: z.array(BrandAliasInput),
  }),
  output: z.object({ success: z.boolean() }),
});
